"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var json_1 = require("../../../../../common/helpers/json");
var saveToDisk_1 = require("../../../../../common/helpers/saveToDisk");
var time_1 = require("../../../../../common/helpers/time");
var AdminInstructorsViewScheduleController = /** @class */ (function () {
    function AdminInstructorsViewScheduleController($state, $stateParams, UsersModel, FlashService) {
        var _this = this;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.loading = true;
        this.filter = {
            start_date: new Date(new Date().setHours(0)),
            end_date: new Date(new Date().setHours(23)),
        };
        this.setStartDate = this.setStartDate.bind(this);
        this.setEndDate = this.setEndDate.bind(this);
        UsersModel.getInstructorSchedule($stateParams.instructorId, {
            start_date: (0, time_1.toYMD)(new Date(this.filter.start_date)),
            end_date: (0, time_1.toYMD)(new Date(this.filter.end_date)),
        }).then(function (response) {
            var items = _this.formatAgenda(response);
            _this.items = (0, lodash_1.sortBy)(items, function (item) {
                return item.timestamp;
            });
            _this.loading = false;
        });
    }
    AdminInstructorsViewScheduleController.prototype.formatAgenda = function (response) {
        var _this = this;
        var _allItems = [];
        if (typeof response.data.drives !== "undefined") {
            response.data.drives
                .filter(function (drive) {
                drive.date = drive.drive_date;
                var startTimeDate = (0, time_1.timeStringToDate)(drive.start_time);
                drive.startTime = (0, time_1.formatDateTime)(startTimeDate, "h:mm A");
                drive.typeDisplay = drive.type.name;
                drive.type = "Drive Session";
                if (drive.private === "Y") {
                    drive.typeDisplay = drive.typeDisplay + " (Hidden)";
                }
                var datetime = new Date(drive.drive_date + " " + drive.start_time);
                drive.timestamp = (0, time_1.getUnixTimestamp)(datetime);
                if (drive.location) {
                    drive.location.address = (0, json_1.isJson)(drive.location.address)
                        ? JSON.parse(drive.location.address)
                        : drive.location.address;
                }
                if (drive.pickuplocation &&
                    drive.pickuplocation.hasOwnProperty("address")) {
                    drive.pickuplocation.address = drive.pickuplocation.address;
                }
                if (drive.dropofflocation &&
                    drive.dropofflocation.hasOwnProperty("address")) {
                    drive.dropofflocation.address = drive.dropofflocation.address;
                }
                var endTimeDate = (0, time_1.addMinutes)(startTimeDate, drive.session_length);
                drive.endTime = (0, time_1.formatDateTime)(endTimeDate, "h:mm A");
                drive.duration = (0, time_1.formatDuration)(drive.session_length);
                drive.actionRequired =
                    drive.hasUngradedReportcards === true &&
                        drive.status === "Taken" &&
                        (0, time_1.isBefore)(datetime, new Date());
                return drive;
            })
                .forEach(function (drive) {
                _allItems.push(drive);
            });
        }
        if (typeof response.data.courses !== "undefined") {
            response.data.courses
                .filter(function (course) {
                course.type = "Course";
                course.typeDisplay = course.name;
                course.location = (0, json_1.isJson)(course.location)
                    ? JSON.parse(course.location)
                    : course.location;
                var courseDate = new Date(course.date);
                var courseDateStr = (0, time_1.formatDateTime)(courseDate, "YYYY-MM-DD");
                var courseDateTime = new Date(courseDateStr + " " + course.time);
                course.timestamp = (0, time_1.getUnixTimestamp)(courseDateTime);
                var startTimeDate = (0, time_1.timeStringToDate)(course.time);
                var endTimeDate = (0, time_1.addMinutes)(startTimeDate, course.duration);
                course.endTime = (0, time_1.formatDateTime)(endTimeDate, "h:mm A");
                course.startTime = (0, time_1.formatDateTime)(startTimeDate, "h:mm A");
                course.duration = (0, time_1.formatDuration)(course.duration);
                course.styling = "course";
                return course;
            })
                .forEach(function (course) {
                _allItems.push(course);
            });
        }
        if (typeof response.data.events !== "undefined") {
            response.data.events
                .filter(function (event) {
                event.typeDisplay = "Event";
                event.type = "Event";
                event.location = (0, json_1.isJson)(event.location)
                    ? JSON.parse(event.location)
                    : event.location;
                var eventDate = new Date(event.date);
                var eventDateStr = (0, time_1.formatDateTime)(eventDate, "YYYY-MM-DD");
                var eventDateTime = new Date(eventDateStr + " " + event.time);
                event.timestamp = (0, time_1.getUnixTimestamp)(eventDateTime);
                var startTimeDate = (0, time_1.timeStringToDate)(event.time);
                var endTimeDate = (0, time_1.addMinutes)(startTimeDate, event.duration);
                event.endTime = (0, time_1.formatDateTime)(endTimeDate, "h:mm A");
                event.startTime = (0, time_1.formatDateTime)(startTimeDate, "h:mm A");
                event.duration = (0, time_1.formatDuration)(event.duration);
                event.styling = "event";
                return event;
            })
                .forEach(function (event) {
                _allItems.push(event);
            });
        }
        if (typeof response.data.timeoffrequests !== "undefined") {
            response.data.timeoffrequests
                .filter(function (rto) {
                rto.typeDisplay = "RTO";
                var _start_ = new Date(rto.begin);
                var _end_ = new Date(rto.end);
                rto.timestamp = (0, time_1.getUnixTimestamp)(_start_);
                rto.styling = "rto";
                // Dont show times for full or range type RTO
                if (rto.type === "full" || rto.type === "range") {
                    var s_date = new Date(_this.filter.start_date);
                    s_date.setHours(23, 59, 0, 0);
                    var e_date = new Date(_this.filter.start_date);
                    e_date.setHours(0, 0, 0, 0);
                    rto.endTime = (0, time_1.formatDateTime)(s_date, "h:mm A");
                    rto.startTime = (0, time_1.formatDateTime)(e_date, "h:mm A");
                    var diffMinutes = (0, time_1.differenceInMinutes)(s_date, e_date);
                    rto.duration = (0, time_1.formatDuration)(diffMinutes);
                }
                else {
                    rto.endTime = (0, time_1.formatDateTime)(_end_, "h:mm A");
                    rto.startTime = (0, time_1.formatDateTime)(_start_, "h:mm A");
                    var diffMinutes = (0, time_1.differenceInMinutes)(_end_, _start_);
                    rto.duration = (0, time_1.formatDuration)(diffMinutes);
                }
                rto.date = (0, time_1.formatDateTime)(_start_, "YYYY-MM-DD");
                return rto;
            })
                .forEach(function (rto) {
                _allItems.push(rto);
            });
        }
        return _allItems.map(function (item) {
            console.log(item);
            item.date = (0, time_1.dateStringToDate)(item.date).toLocaleDateString("en-US");
            return item;
        });
    };
    AdminInstructorsViewScheduleController.prototype.isEvent = function (item) {
        return item.type === "Event";
    };
    AdminInstructorsViewScheduleController.prototype.isCourse = function (item) {
        return item.type === "Course";
    };
    AdminInstructorsViewScheduleController.prototype.isDriveSession = function (item) {
        return item.type === "Drive Session";
    };
    AdminInstructorsViewScheduleController.prototype.submit = function () {
        var _this = this;
        this.loading = true;
        this.UsersModel.getInstructorSchedule(this.$stateParams.instructorId, {
            start_date: (0, time_1.toYMD)(new Date(this.filter.start_date)),
            end_date: (0, time_1.toYMD)(new Date(this.filter.end_date)),
        }).then(function (response) {
            var items = _this.formatAgenda(response);
            _this.items = (0, lodash_1.sortBy)(items, function (item) {
                return item.timestamp;
            });
            _this.loading = false;
        });
    };
    AdminInstructorsViewScheduleController.prototype.setStartDate = function (newDate) {
        this.filter.start_date = new Date(newDate.selected[0]);
    };
    AdminInstructorsViewScheduleController.prototype.setEndDate = function (newDate) {
        this.filter.end_date = new Date(newDate.selected[0]);
    };
    AdminInstructorsViewScheduleController.prototype.print = function () {
        var _this = this;
        this.UsersModel.printInstructorSchedule(this.$stateParams.instructorId, {
            start_date: (0, time_1.toYMD)(new Date(this.filter.start_date)),
            end_date: (0, time_1.toYMD)(new Date(this.filter.end_date)),
        }).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            (0, saveToDisk_1.saveToDisk)(response.url);
            _this.loading = false;
        });
    };
    return AdminInstructorsViewScheduleController;
}());
AdminInstructorsViewScheduleController.$inject = [
    "$state",
    "$stateParams",
    "UsersModel",
    "FlashService",
];
exports.default = AdminInstructorsViewScheduleController;
